import React from 'react';

interface QRCodeDisplayProps {
    qrCodeUrl: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ qrCodeUrl }) => {
    return (
        <div>
            {qrCodeUrl ? (
                <div style={{ textAlign: 'center' }}>
                    <img src={qrCodeUrl} alt="Generated QR Code" style={{ maxWidth: '300px', marginBottom: '10px' }} />
                    {/* <p style={{ fontSize: '12px', color: '#888' }}>Generated by Midhaan</p> */}
                </div>
            ) : (
                <p>No QR code generated yet.</p>
            )}
        </div>
    );
};

export default QRCodeDisplay;